module.exports = __webpack_public_path__ + "img/spotify.cb65e80c.png";